/* eslint-disable @typescript-eslint/naming-convention */
export const commonConstants = {
  LAST_URL_BEFORE_LOGIN: 'lastURLBeforeLogin',
  OBJECT: 'object',
  LOGGED_OUT_MESSAGE: 'LoggedOutMessage',
  ERROR: 'error',
  OK: 'ok',
  IS_BEING_LOGGED_OUT: 'isBeingLoggedOut',
  INIT_ERROR: 'initError',
  LOGIN: 'login',
  SPLASH_SCREEN: 'SplashScreen',
  LOGIN_VIEW: 'login-view',
  SSO: 'sso',
  UNAUTHORIZED: 'Unauthorized',
  SUCCESS: 'success',
  DELETE_HEADER: 'deleteHeader',
  DELETE_MSG: 'deleteMessage',
  INFO: 'info',
  WARNING: 'warning',
  DANGER: 'danger',
  STRING: 'string',
  BOOLEAN: 'boolean',
  NUMBER: 'number',
  NULL: 'null',
  CANCEL: 'cancel',
  CONFIRM: 'confirm',
  SECONDARY: 'secondary',
  REFRESH_TOKEN_EXPIRES_IN: 30,
  INACTIVE_USER: 'Inactive user',
  UNASSIGN_VENDOR_GROUP: 'unassignVendorGroup',
  UNASSIGN_SALES_REP: 'unassignSalesRep',
  ASSIGN_VENDOR_SALES_REP: 'assign-vendor-sales-rep',
  EDIT_WALKLIST: 'edit-walklist',
  COMPLETE_TERRITORY: 'completeTerritory',
  CLOSE_TERRITORY: 'closeTerritory',
  CONFIRM_BUTTON: 'confirm-button',
  CANCEL_BUTTON: 'cancel-button',
  ACTIONS: {
    GET: 'get',
    PUT: 'put',
    CREATE: 'create',
    DELETE: 'delete',
  },
  DATE_FORMATS: {
    DDMMMYYY: 'ddMMMyyyy',
    yyyy_MM_DD: 'yyyy-MM-dd',
    MMMdd_YYYY_HHmm_a: 'MMM dd, YYYY hh:mm a',
  },
};

export enum territoryStatus {
  create = 'Created',
  walklistsUnassigned = 'Walklists Unassigned',
  walklistsAssigned = 'Walklists Assigned',
  inProgress = 'In Progress',
}

export enum DsaProducts {
  internet = 'internet',
  pik = 'pik',
  optik = 'optik',
  satelliteTv = 'satelliteTv',
  homePhone = 'homePhone',
  telusOnlineSecurity = 'telusOnlineSecurity',
  livingWellCompanion = 'livingWellCompanion',
  streamPlus = 'streamPlus',
  security = 'security',
  mobility = 'mobility',
  shub = 'smarthub',
}

export enum DsaAvailableProducts {
  pik = 'Pik TV',
  optik = 'Optik TV',
  homePhone = 'HP',
  security = 'SHS',
}

// TODO: add new products to appear under existing in the address detail page here. Ex: streamPlus
export enum DsaExistingProducts {
  pik = 'Pik TV',
  optik = 'Optik TV',
  homePhone = 'HP',
  smarthub = 'Smart Hub',
  satelliteTv = 'STV',
  livingWellCompanion = 'LWC',
  streamPlus = 'Stream+',
}

export enum HsmMobilityType {
  telus = 'TELUS Mobility',
  koodo = 'Koodo',
  public = 'Public',
}

export enum TerritoryType {
  CONSUMER = 'Consumer',
  BUSINESS = 'Business',
}
